module.exports = __webpack_public_path__ + "static/media/cv_icon.eaaec8a8.svg";